import React, { useState, useRef, useEffect } from 'react';
import { NavLink, useNavigate, Outlet, useLocation } from 'react-router-dom';
import {
  Boxes, Package, ArrowLeftRight, ClipboardList, PackageCheck, Bell,
  Settings, ChevronDown, Menu, X, LogOut, Store, Layers, Factory, Truck,
  Upload, Users
} from 'lucide-react';
import api from '../services/api';

const RUTE_SETARI = ['/magazii', '/materiale', '/produse', '/furnizori', '/import-date', '/utilizatori'];

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const rol = localStorage.getItem('rol');
  const nume = localStorage.getItem('nume');
  const [setariDeschise, setSetariDeschise] = useState(false);
  const [meniuMobilDeschis, setMeniuMobilDeschis] = useState(false);
  const [nrAlerte, setNrAlerte] = useState(0);
  const ref = useRef(null);
  const setariActive = RUTE_SETARI.some(r => location.pathname.startsWith(r));

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setSetariDeschise(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    api.get('/api/stoc/alerte').then(res => setNrAlerte(res.data.length)).catch(() => {});
  }, [location.pathname]);

  // Inchide meniul mobil automat cand se schimba pagina.
  useEffect(() => { setMeniuMobilDeschis(false); }, [location.pathname]);

  async function logout() {
    try { await api.post('/api/auth/logout'); } catch (e) { /* continuam oricum cu curatarea locala */ }
    localStorage.removeItem('token');
    localStorage.removeItem('rol');
    localStorage.removeItem('nume');
    navigate('/login');
  }

  const linkClass = ({ isActive }) => `navlink ${isActive ? 'active' : ''}`;

  return (
    <div className="app-shell-top">
      <nav className="topnav">
        <button className="topnav-burger" onClick={() => setMeniuMobilDeschis(!meniuMobilDeschis)} aria-label="Meniu">
          {meniuMobilDeschis ? <X size={22} /> : <Menu size={22} />}
        </button>
        <div className="topnav-brand">
          <span className="logo-cub"><Boxes size={18} color="#fff" /></span>
          <span className="brand-text">Stocuri</span>
        </div>

        <div className={`topnav-links${meniuMobilDeschis ? ' deschis' : ''}`}>
          <NavLink to="/" end className={linkClass}><Package size={16} className="icon" />Stoc curent</NavLink>
          <NavLink to="/miscari" className={linkClass}><ArrowLeftRight size={16} className="icon" />Miscari stoc</NavLink>
          <NavLink to="/comenzi" className={linkClass}><ClipboardList size={16} className="icon" />Comenzi</NavLink>
          <NavLink to="/produse-finite" className={linkClass}><PackageCheck size={16} className="icon" />Produse finite</NavLink>
          <NavLink to="/alerte" className={linkClass}>
            <Bell size={16} className="icon" />Alerte
            {nrAlerte > 0 && <span className="alerte-count">{nrAlerte}</span>}
          </NavLink>
          <div className="topnav-dropdown" ref={ref}>
            <button className={`navlink navlink-btn ${setariActive ? 'active' : ''}`} onClick={() => setSetariDeschise(!setariDeschise)}>
              <Settings size={16} className="icon" />Setari <ChevronDown size={14} className={`caret ${setariDeschise ? 'sus' : ''}`} />
            </button>
            {setariDeschise && (
              <div className="topnav-dropdown-menu">
                <NavLink to="/magazii" onClick={() => setSetariDeschise(false)}><Store size={15} />Denumire magazii</NavLink>
                <NavLink to="/materiale" onClick={() => setSetariDeschise(false)}><Layers size={15} />Nomenclator materiale</NavLink>
                <NavLink to="/produse" onClick={() => setSetariDeschise(false)}><Factory size={15} />Nomenclator produse</NavLink>
                <NavLink to="/furnizori" onClick={() => setSetariDeschise(false)}><Truck size={15} />Furnizori</NavLink>
                {rol === 'admin' && <NavLink to="/import-date" onClick={() => setSetariDeschise(false)}><Upload size={15} />Import initial de date</NavLink>}
                {rol === 'admin' && <NavLink to="/utilizatori" onClick={() => setSetariDeschise(false)}><Users size={15} />Utilizatori</NavLink>}
              </div>
            )}
          </div>
        </div>

        <div className={`topnav-overlay${meniuMobilDeschis ? ' deschis' : ''}`} onClick={() => setMeniuMobilDeschis(false)} />

        <div className="topnav-user">
          <span className="user-nume">{nume}</span>
          <button className="btn-logout" onClick={logout}><LogOut size={14} />Iesire</button>
        </div>
      </nav>

      <div className="content-top">
        <Outlet />
      </div>

      <footer className="app-footer">
        <span>&copy; {new Date().getFullYear()} Gestiune Stocuri &mdash; o marca a <a href="https://softconsult.ro" target="_blank" rel="noopener noreferrer">Software Consulting SRL</a></span>
      </footer>
    </div>
  );
}
